import type { DefinitionHiddenGate, DefinitionHiddenOption } from './types';

export type FeatureFlagsList = Record<string, unknown>;

interface ResourceOptions {
  hidden?: DefinitionHiddenOption;
}

const isResourceHiddenByGate = (
  gate: DefinitionHiddenGate | undefined,
  availableFeatureFlags: FeatureFlagsList,
) => {
  const gateFlags = gate?.flags ?? [];
  if (gateFlags.length === 0) {
    return false;
  }

  const condition = gateFlags.length > 1 ? gate?.condition ?? 'and' : 'and';
  const isFlagSatisfied = ({ name, value }: DefinitionHiddenGate['flags'][number]) =>
    Boolean(availableFeatureFlags[name]) === value;

  return condition === 'or' ? gateFlags.some(isFlagSatisfied) : gateFlags.every(isFlagSatisfied);
};

export const isResourceHiddenByOptions = (
  options: ResourceOptions | null | undefined,
  availableFeatureFlags: FeatureFlagsList,
) => {
  const hidden = options?.hidden;
  if (typeof hidden === 'object' && hidden !== null && 'gate' in hidden) {
    return isResourceHiddenByGate(hidden.gate, availableFeatureFlags);
  }
  return !!hidden;
};
